import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IncludeHtmlViewer = _resolveComponent("IncludeHtmlViewer")!

  return (_openBlock(), _createBlock(_component_IncludeHtmlViewer, {
    htmlName: _ctx.html,
    hash: _ctx.hash
  }, null, 8, ["htmlName", "hash"]))
}